import { FC, ReactNode } from 'react';

interface OrderStepPlaceholderProps {
  title: string;
  description: string;
  children?: ReactNode;
}

const OrderStepPlaceholder: FC<OrderStepPlaceholderProps> = ({
  title,
  description,
  children,
}) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
    <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
    <p className="mt-2 text-sm text-slate-500">{description}</p>
    {children ? <div className="mt-4">{children}</div> : null}
  </div>
);

export default OrderStepPlaceholder;
